import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Col, Row, Statistic, Tag, Tooltip } from 'antd';
import React from 'react';

export type StatisticItem = {
  title: string | React.ReactNode;
  value: number | string;
  extraFinancialData?: string;
  tooltip?: string;
  tag?: string;
  tagColor?: string;
};

type ReportStatisticsProps = {
  title: string | React.ReactNode;
  statistics: StatisticItem[];
  columnWidth?: number;
  isSummaryMode?: boolean;
};

const ReportStatistics: React.FC<ReportStatisticsProps> = ({ title, statistics, columnWidth, isSummaryMode = false }) => {
  return (
    <Card 
      bordered 
      className="report-statistics-card"
      title={
        !isSummaryMode 
        ? <span style={{ display: 'flex', justifyContent: 'space-between' }}><span>{title}</span></span> 
        : null}
      >
      <Row>
        {statistics.map((stat, index) => (
          <Col span={columnWidth ?? 3} key={index}>
            <Statistic title={stat.title} value={stat.value} />
            {stat.extraFinancialData}
            {stat.extraFinancialData ? <br /> : null}
            {stat.tag && <Tag color={stat.tagColor || 'green'}>{stat.tag}</Tag>}
            {stat.tooltip && (
              <Tooltip title={stat.tooltip}>
                <FontAwesomeIcon icon={faInfoCircle} />
              </Tooltip>
            )}
          </Col>
        ))}
      </Row>
    </Card>
  );
};

export default ReportStatistics;